"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentSubmissionOrchestrator = void 0;
const ExternalS3FileUploader_1 = require("../s3/ExternalS3FileUploader");
const GraphQLGetPresignedUploadURLClient_1 = require("../s3/GraphQLGetPresignedUploadURLClient");
const GraphQLHandleExternalReportSubmissionClient_1 = require("../report/GraphQLHandleExternalReportSubmissionClient");
class AssessmentSubmissionOrchestrator {
    constructor(graphQLAPI) {
        this.client = new GraphQLHandleExternalReportSubmissionClient_1.GraphQLHandleExternalReportSubmissionClient(graphQLAPI);
        this.fileUploader = new ExternalS3FileUploader_1.ExternalS3FileUploader(new GraphQLGetPresignedUploadURLClient_1.GraphQLGetPresignedUploadURLClient(graphQLAPI));
    }
    submitAssessment(submission, stagedImages) {
        return __awaiter(this, void 0, void 0, function* () {
            const submissionImages = yield Promise.all(stagedImages.map((image) => __awaiter(this, void 0, void 0, function* () {
                const key = yield this.fileUploader.uploadImage(image.file);
                return { key: key, imageSource: image.imageSource };
            })));
            let submissionWithImages;
            if (!submission.issues || submission.issues.length === 0) {
                submissionWithImages = Object.assign(Object.assign({}, submission), { images: submissionImages });
            }
            else {
                submissionWithImages = Object.assign(Object.assign({}, submission), { issues: [
                        Object.assign(Object.assign({}, submission.issues[0]), { images: submissionImages })
                    ] });
            }
            yield this.client.handleExternalReportSubmission(submissionWithImages);
        });
    }
}
exports.AssessmentSubmissionOrchestrator = AssessmentSubmissionOrchestrator;
